module.exports = __webpack_public_path__ + "static/img/bg_index_head.e8ad987.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_index_head.png
// module id = jLkX
// module chunks = 23